<template>
    <section id="all_transactions">
        <div class="top_section">
            <h1 class="font-apercu-bold is-size-4">Invoices</h1>
        </div>
        <div id="main-card">
            <div class="card-head">
                <div class="l-sec">
                    <input type="text" placeholder="Search for transaction" />
                </div>
                <div class="r-sec">
                    <button class="button">Export</button>
                </div>
            </div>
            <div class="table">
                <table>
                    <thead>
                        <tr>
                            <th>Invoice ID</th>
                            <th class="text-center">Data</th>
                            <th class="text-center">Amount</th>
                            <th class="text-center">NO. of orders</th>
                            <th class="text-center">Due date</th>
                            <th class="text-center">Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>01254103652</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center primary">70.20 SAR</td>
                            <td class="text-center">-</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center">Deposit</td>
                            <td>Deposit</td>
                        </tr>
                        <tr>
                            <td>01254103652</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center primary">70.20 SAR</td>
                            <td class="text-center">-</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center">Deposit</td>
                            <td>Deposit</td>
                        </tr>
                        <tr>
                            <td>01254103652</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center primary">70.20 SAR</td>
                            <td class="text-center">-</td>
                            <td class="text-center">13 MAY 2020</td>
                            <td class="text-center">Deposit</td>
                            <td>Deposit</td>
                        </tr>

                        <tr>
                            <td>
                                <p>01254103652</p>
                                <p>01254103652</p>
                                <p>01254103652</p>
                                <p class="total">TOTAL</p>
                            </td>
                            <td class="text-center">
                                <p>13 MAY 2020</p>
                                <p>13 MAY 2020</p>
                                <p>13 MAY 2020</p>
                                <p style="color: white;">total</p>
                            </td>
                            <td class="text-center danger">
                                <p>-70.20 SAR</p>
                                <p>-70.20 SAR</p>
                                <p>-70.20 SAR</p>
                                <p>-280.80 SAR</p>
                            </td>
                            <td class="text-center">BR-25214522654</td>
                            <td class="text-center">
                                <p>13 MAY 2020</p>
                                <p>13 MAY 2020</p>
                                <p>13 MAY 2020</p>
                                <p style="color: white;">total</p>
                            </td>
                            <td class="text-center">Deposit</td>
                            <td>Deposit</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        userData() {
            return this.$store.getters.userData;
        },
    },
};
</script>

<style lang="scss"></style>
